"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BaseClass_1 = __importDefault(require("./BaseClass"));
/**
 * Merchant profile related functions
 * @public
 */
class MailSubscription extends BaseClass_1.default {
    constructor(apiV1, apiV2) {
        super(apiV1, apiV2);
    }
    /**
     * Function to subscribe new letter
     * @returns empty result
     */
    async subscribe(email) {
        try {
            const data = await this._apiV2.mailSubscriptionAPI.subscribe(email);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to mark user viewed tutorial
     * @returns empty result
     */
    async unsubscribe() {
        try {
            const data = await this._apiV2.mailSubscriptionAPI.unsubscribe();
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
}
exports.default = MailSubscription;
